import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FilterValueType } from '../../filtered-search.component';

@Component({
  selector: 'slide-toggle-filter',
  styleUrl: '../filtered-search-option.component.scss',
  standalone: true,
  imports: [MatSlideToggleModule, ReactiveFormsModule],
  template: `
    <mat-slide-toggle
      (keyup)="$event.stopPropagation(); $event.preventDefault()"
      (click)="$event.stopPropagation()"
      [formControl]="control"
      [attr.data-test]="'filter-boolean-filter'"
    >
      {{ placeholder || 'Enable' }}
    </mat-slide-toggle>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlideToggleFilterComponent {
  readonly locale = inject<L10nLocale>(L10N_LOCALE);

  @Input() control: FormControl<FilterValueType>;
  @Input() placeholder?: string;
}
